import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgTretinoinGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M29.78 20.45c-1.95 0-3.99.84-5.33 2.62V9.5h11.4a.749.749 0 1 0 0-1.5h-24.1c-.41 0-.75.34-.75.75s.34.75.75.75h11.2v29.75c0 .41.34.75.75.75s.75-.34.75-.75V28.07c0-4.83 3.35-6.12 5.33-6.12 5.07 0 5.33 5.68 5.33 6.82 0 .41.34.75.75.75s.75-.34.75-.75c-.01-3.83-1.8-8.32-6.83-8.32Z",
    fill: "currentColor"
  }));
}

export { SvgTretinoinGlyphSecondary as default };
